function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defaultGraphInstance } from '@rdf-esm/data-model';
import TermMap from '@rdf-esm/term-map';
export default class CachedResourceFactoryImpl {
  constructor(inner) {
    _defineProperty(this, "__cache", void 0);

    _defineProperty(this, "__inner", void 0);

    this.__cache = new TermMap();
    this.__inner = inner;
  }

  removeCache(graph) {
    this.__cache.delete(graph);
  }

  clone() {
    return new CachedResourceFactoryImpl(this.__inner);
  }

  createEntity(pointer, typeAndMixins, options) {
    const graph = pointer._context[0].graph || defaultGraphInstance;

    if (!this.__cache.has(graph)) {
      this.__cache.set(graph, new TermMap());
    }

    const graphCache = this.__cache.get(graph);

    if (!graphCache.has(pointer.term)) {
      const resource = this.__inner.createEntity(pointer, typeAndMixins, options);

      graphCache.set(pointer.term, resource);
    }

    return graphCache.get(pointer.term);
  }

  addMixin(...mixins) {
    this.__inner.addMixin(...mixins);
  }

}